module.exports = __webpack_public_path__ + "assets/img/bthree.b7a51449.png";